import { FC } from 'react';
import cx from 'clsx';
import { isSameDay } from 'date-fns';
import styles from './styles.module.css';

type Props = {
  date: Date;
  label: string;
  isInCampaignRange: boolean;
  onDateClick: (date: Date) => void;
};

export const MonthDateHeader: FC<Props> = ({
  date,
  label,
  isInCampaignRange,
  onDateClick,
}) => {
  const isToday = isSameDay(date, new Date());

  const handleDateHeaderClick = () => {
    onDateClick(date);
  };

  return (
    <button
      className={cx({
        [styles.cell]: true,
        [styles.cellDisabled]: !isInCampaignRange,
        [styles.cellToday]: isToday,
      })}
      onClick={handleDateHeaderClick}
    >
      <span>{label}</span>
    </button>
  );
};
